import BankTransfer from "./Banktransfer";
import { useState } from "react";

const ChangePayout = ({updateModal}) => {
      const [method, setMethod] = useState("banktrans");

      const selectPayout = (e, method) => {
            setMethod(method);
            let selectedPayout = e.target;
            let parNode = e.target.parentNode;
            console.log(parNode);
            Array.from(parNode.children).forEach((child) => {
                  child.classList.remove("selectedPayoutmet");
            });
            selectedPayout.classList.add("selectedPayoutmet");
      };
  return (
    <>
      <div onClick={()=>updateModal(false)} className='changePayout34wrapper'>
        <div onClick={(e)=>e.stopPropagation()} className='changePayoutDiv2'>
          <h5>Select payout method</h5>
          <div className='slectepayoutMethoddiv'>
            <div className='s821654buy'>
              <button onClick={(e)=>selectPayout(e, "banktrans")} className='selectedPayoutmet'>Bank transfer</button>
              <button onClick={(e)=>selectPayout(e, "paypal")}> Paypal</button>
              <button onClick={(e)=>selectPayout(e, "hubCoin")}> HubCoin </button>
            </div>
          </div>
         {method==="banktrans" && <BankTransfer openModal={updateModal} />}
        </div>
      </div>
    </>
  );
};

export default ChangePayout;
